import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { queryClient, QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';
import { updateProjectListingProjectFit } from '@/api/v4/project-fit.api';

export const useUpdateProjectFit = () => {
  const { t } = useTranslation('default');

  const mutation = useMutation({
    mutationFn: updateProjectListingProjectFit,
    onError: (error: Error) => {
      notify({
        message: t`unknownError`,
      });
      console.error(error.message);
    },
    onSuccess: async (_data, { projectListingId }) => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.ProjectListingProjectFit, projectListingId],
      });
    },
  });

  return {
    updateProjectFit: mutation.mutateAsync,
    isError: mutation.isError,
  };
};
